import "./Banner.css";

const Banner = () => {
  return (
    <header className="banner">
      <img src="/imagens/banner.png" alt="imagem do banner principal" />
    </header>
  );
};

export default Banner;
